import type { ReactNode } from 'react';

export function V3EmptyBlock(props: {
  readonly title: string;
  readonly text: string;
  readonly icon?: ReactNode;
  readonly actions?: ReactNode;
}) {
  return (
    <div
      className="v3-card v3-empty"
      data-od-id="empty-block"
    >
      <span
        className="ico"
        aria-hidden="true"
      >
        {props.icon}
      </span>
      <h2 className="text-base font-bold">{props.title}</h2>
      <p
        className="v3-mu"
        style={{ maxWidth: '56ch' }}
      >
        {props.text}
      </p>
      {props.actions ? <div className="v3-lk">{props.actions}</div> : null}
    </div>
  );
}

export function V3ErrorBlock(props: {
  readonly title: string;
  readonly onRetry?: () => void;
}) {
  return (
    <div
      className="v3-card v3-empty"
      role="alert"
      data-od-id="error-block"
    >
      <span className="v3-chip c-bad">Fehler</span>
      <h2 className="text-base font-bold">{props.title}</h2>
      <p className="v3-mu">
        Die Verbindung zum Server wurde unterbrochen. Ihre Daten sind nicht
        betroffen.
      </p>
      {props.onRetry ? (
        <div className="v3-lk">
          <button
            type="button"
            className="v3-btn pri"
            data-od-id="error-retry"
            onClick={props.onRetry}
          >
            Erneut versuchen
          </button>
        </div>
      ) : null}
    </div>
  );
}

export function V3Skeleton() {
  return (
    <div
      className="v3-stack"
      aria-busy="true"
    >
      <div
        className="v3-sk"
        style={{ height: 32, width: 220 }}
      />
      <div
        className="v3-sk"
        style={{ height: 96 }}
      />
      <div
        className="v3-sk"
        style={{ height: 160 }}
      />
    </div>
  );
}

export const V3ArrowIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

export const V3DocIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M6 2h9l5 5v15H6zM14 2v6h6" />
  </svg>
);

export const V3UsersIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle
      cx="9"
      cy="8"
      r="4"
    />
    <path d="M2 21v-1a6 6 0 0112 0v1M16 4a4 4 0 010 8M22 21v-1a6 6 0 00-4-5.6" />
  </svg>
);
